import { Button, createTheme } from '@mantine/core';
import { themeToVars } from '@mantine/vanilla-extract';

export const theme = createTheme({
    primaryColor: 'hha',
    colors: {
        'hha': [
            '#dee4e1ff', '#C3FAE8', '#96F2D7', '#63E6BE', '#38D9A9',
            '#20C997', '#12B886', '#0CA678', '#099268', '#087F5B', 
        ],
    },
    components: {
        Button: Button.extend({
            defaultProps: {
                color: 'teal',
                variant: 'outline',
            },
        }),
    },
});

export const vars = themeToVars(theme);
